import React from 'react';
import NotificationBell from './NotificationBell';

function Topbar({ profile, onMenuClick }) {
  if (!profile) return null;
  return (
    <div className="topbar">
      <button className="topbar-hamburger" onClick={onMenuClick} aria-label="Abrir menú">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 7h16" />
          <path d="M4 12h16" />
          <path d="M4 17h16" />
        </svg>
      </button>
      <div className="topbar-right">
        {profile.status === 'active' && <NotificationBell isAdmin={['admin', 'owner'].includes(profile.role)} />}
      </div>
    </div>
  );
}

export default Topbar;
